const Config = {
  URL: 'https://www.playgokids.com',
  BLOG_URL: 'https://tech.playgokids.com',
}

export default Config
